import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import Coa5 from "../../../containers/modules/accounting/coa5";

export default function Coa5Route(props) {
  const { authUser } = props;
  return (
    <Route
      path="coa5"
      index
      element={
        <AccessControl
          name={"Coa5 List"}
          auth={authUser}
          component={() => <Coa5 />}
        />
      }
    />
  );
}
